module.exports = __webpack_public_path__ + "AdobeStock_161673435_shaded4.png?dfdc79706af6decd6a577232765465a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_161673435_shaded4.png
// module id = 316
// module chunks = 0